import useInfiniteService from '@/data/hook/useInfiniteService';
import { REQUEST_STALE_TIME_IN_MS } from '@/constants';
import { updateProject } from '@/data/services/projectServices';
import { flagsQueryKeys } from '@/data/services/querykeys';
import { FlagTypeEnum } from '@/models/Flag';
import { Project } from '@/models/Project';
import { hasFinalistTag } from '@/utils/hackathon';
import { useMutation } from '@tanstack/react-query';

export const useFinalist = (
  project: Project,
  onMutate?: (project: Project) => void,
) => {
  const { results, isInitialLoading: isLoadingFlag } = useInfiniteService({
    ...flagsQueryKeys.list({ type: FlagTypeEnum.FINALIST }),
    staleTime: REQUEST_STALE_TIME_IN_MS,
  });
  const finalistFlag = results.at(0);
  const flagsIds = project.flags?.map(flag => flag.id) || [];
  const addFinalist = async () => {
    if (!finalistFlag) return;
    return updateProject(project.id, {
      flagsIds: flagsIds.concat(finalistFlag?.id),
    });
  };

  const removeFinalist = async () => {
    if (!finalistFlag) return;
    return updateProject(project.id, {
      flagsIds: flagsIds?.filter(flagId => flagId !== finalistFlag?.id),
    });
  };
  const isFinalist = hasFinalistTag(project);

  const handleFinalist = async () => {
    if (isFinalist) {
      return await removeFinalist();
    }
    return await addFinalist();
  };

  const { mutate: setFinalist, isLoading: isUpdating } = useMutation(
    handleFinalist,
    {
      onSuccess(data) {
        if (data && onMutate) {
          onMutate(data);
        }
      },
    },
  );

  return { setFinalist, isUpdating: isUpdating || isLoadingFlag };
};
